import { NxGridModule } from "@allianz/ng-aquila/grid";
import { NxLinkModule } from "@allianz/ng-aquila/link";
import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-auth-side-header",
  imports: [RouterModule, NxGridModule, NxLinkModule, TranslateModule],
  templateUrl: "./auth-side-header.component.html",
  styleUrls: ["./auth-side-header.component.scss"],
})
export class AuthSideHeaderComponent {}
